import { render, staticRenderFns } from "./PrivateMessageNotice.vue?vue&type=template&id=02e09341&"
import script from "./PrivateMessageNotice.vue?vue&type=script&lang=js&"
export * from "./PrivateMessageNotice.vue?vue&type=script&lang=js&"
import style0 from "./PrivateMessageNotice.vue?vue&type=style&index=0&id=02e09341&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports